<template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:60px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">新增 </span></el-link>
                </div>
 
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:150px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
   
            </div>
        </div>
        <el-table  :data="poData" 
              border                            
              size="small"
              class="custom-table-border"
              :cell-style="{padding:'2px','font-size':'12px',color:'black' }"
              header-cell-class-name="clearPadding"
              v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              ref="refreq"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed align="center">
                <el-table-column label="序号" type="index" width="60" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column> 
            <el-table-column   v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='STFG'" @change="stfgChange" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="已审" value="Y"  ></el-option>
                            <el-option label="未审" value="N"  ></el-option>
                        </el-select>
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="stfgChange" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'||item.key=='SEL'" v-else @keyup.enter.native="stfgChange"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column>
            </el-table-column> 
             <el-table-column
                fixed="right"
                label="状态操作"
                align="center"
                width="210">
                <template slot-scope="scope">
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link  @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px">查看</span></el-link> 
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="editRec(scope.row,'N',scope.$index)" :underline="false" style="font-size:10px;margin-right:5px; "><span style="font-size:12px;margin-right:5px">编辑</span></el-link> 
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'Y',scope.$index,'审核')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'N',scope.$index,'弃审')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="stfgRec(scope.row,'X',scope.$index,'作废')" :underline="false" ><span style="font-size:12px;">作废</span></el-link> 
                    </span>
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag||item.disabled==='Y'" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="small" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-checkbox v-else-if="item.edcss=='checkbox'"  true-label="Y" false-label="N" v-model="poRow[item.key]"></el-checkbox>
                            <el-input size="small" :disabled="saveFlag" @focus="inputBtn('','', item.key)" v-else-if="item.edcss=='button'"   v-model="poRow[item.key]" style="width:100%"> </el-input>  
                            <el-select size="small" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="small" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar"><span class="spanRow"> 明细资料</span>
                    【
                        <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="dtlAdd" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">新增明细</span></el-link>   
                    】
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    style="margin-top:-8px"
                    @row-click="rowClick"
                    :cell-style="{padding:'2px','font-size':'12px'}"
                    ref="refdtl"
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row > 
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else-if="item.key=='DEPTNO'" v-text="scope.row['DEPTNM']"> </span>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >                    
                                <el-select size="mini" v-if="item.key=='DEPTNO'" @change="deptChg(scope.row)" v-model="scope.row[item.key]">
                                    <el-option v-for="(item,index) in deptArr" :label="item.CNAME" :value="item.CODE" :key="index"></el-option>
                                </el-select>
                                <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="'pos'+scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                <el-input type="number" @input="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-date-picker :disabled="item.disabled=='N'?false:true"  :ref="'pos'+scope.$index+item.key" type="date" size="mini" v-else-if="item.edcss==='date'" v-model="scope.row[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                                <el-checkbox :disabled="item.disabled=='N'?false:true" true-label="Y" false-label="N" :ref="'pos'+scope.$index+item.key"   v-else-if="item.edcss=='checkbox'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-checkbox> 
                                <el-input  @keyup.enter.native="nextLine(item.key,'enter','refpos')" @keyup.down.native="nextLine(item.key,'down','refpos')" @keyup.up.native="nextLine(item.key,'up','refpos')"  :ref="'pos'+scope.$index+item.key"   v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>    
                 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>
  
                        </template>
                    </el-table-column>  
                </el-table>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> 提示：订单审核后不能再编辑 , 如需编辑请弃审</i> 
                    <span style="margin-right:30px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
export default {
    name:'qc_procedure',
    data () {
        return {
            v_row:{},
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            taskCol:[],
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            appBool:false,
            v_commit :true,
            promptWin:false,
            hrCol:[],
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            v_admin:this.$cookies.get('v_admin') , 
            rowDtl:{},
            btnWin:false,
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            v_loading:false,
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
  
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            tabCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
            v_index:'',
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            deptArr:[],
        }
    },
    components: {
      pubWin,  
      repWin,
   
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 158) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 240) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        this.showkey()
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
        getBaseData(this.v_url,'CORPID',this.v_corpid ,'','','v_HR_DEPT','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412735','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','412735','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412735','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('') //询价单主数据   
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        rowShow(){
            this.v_row ={}
            this.stfgChange()
        } ,
        qtyPrc(row,index,key){           
            let v_qty1=0,v_qty2=0,v_qty3=0
            if (!row['SZQTY']){
                v_qty1 =0
            }else{
                v_qty1=row['SZQTY']
            }
            if (!row['LOOKQTY']){
                v_qty2 =0
            }else{
                v_qty2=row['LOOKQTY']
            }
            if (!row['OTHQTY']){
                v_qty3 =0
            }else{
                v_qty3=row['OTHQTY']
            }
            row['BADQTY']= Number(v_qty1)+Number( v_qty2) +Number( v_qty3)        
         
        },
        dropSel(val){
            if (val =='sendRep'){ //分发
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+  'file_send.cpt' +'&p_corpid='+ this.v_corpid

            }else if (val=='backRep'){ //回收
                this.repWin =true
                this.repUrl =this.$store.state.repUrl+  'file_back.cpt' +'&p_corpid='+ this.v_corpid
            }
        },
        deptChg(row){
            row['EMPNO'] =''
            row['EMPNM'] =''
        },  
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key,val,reftab){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    if (reftab=='refpos'){
                        v_count =this.dtlData.length
                    }
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    if (reftab=='refpos'){
                        this.$refs['pos'+this.chkIndex+'JOBDESC'][0].focus()  
                    } 
                }else{
                    if (reftab=='refpos'){
                        let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                        v_col.some((item,index)=>{
                            if (item.key==key){
                               this.$refs['pos'+this.chkIndex+ v_col[index+1].key][0].focus()  
                            }
                        })
                    }
                }
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1
                if (reftab=='refpos'){
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                }
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }              
                if (reftab=='refpos'){
                    this.$refs['pos'+this.chkIndex+key][0].focus()  
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                } 
            }                    
        },
        btnSure(obj){
            if (this.v_key =='TASKNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ TASKNO:obj['IDNO'],PRDNM:obj['MATNM'],WKNM:obj['WKNM'],PRDQTY:obj['QTY'],JOBNM:obj['CJOBNM'],REFIDSEQ:obj['IDSEQ'],REFLSTSEQ:obj['LSTSEQ'] ,ORDNO:obj['ORDNO']} ))
                this.$refs['pos'+ this.v_tabIndex+'CHKQTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            }else{
                Object.assign(this.poRow,{RFILENM:obj['FILENM'],RFILENO:obj['FNO'],VER:obj['VER'],REFIDSEQ:obj['IDSEQ'],REFLSTSEQ:obj['LSTSEQ'] })     
            }
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='EMPNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_HR_EMP'
                this.tableCol =this.hrCol
                this.v_key2 ='DEPTNO'
                this.v_value2 = row['DEPTNO']
                this.btnWin =true
            }else if (key=='TASKNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_pc_taskDTL'
                this.tableCol =this.taskCol
                this.v_key2 =''
                this.v_value2 = ''
                this.btnWin =true
            }
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        // 明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.v_loading =true
            getTabColOrData(this.v_url,'V_qc_chkdtl','idseq',idseq,'','','','',' ORDER BY lstseq' ).then((res) => { 
                this.dtlData =res.result 
            })
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout()
                this.v_loading =false
            }) 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'412735',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
 
        dtlAdd(){
 
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['ISCHK']='Y'
            this.dtlData.push(v_row)
            this.delDtlArr=[]
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.v_index =index
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            //明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
            this.v_commit =true   
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                let v_title=false  
                this.dtlData.forEach(item=>{
                    this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                        if (!item[it.key]){
                            v_title =it['title']
                            return true
                        }
                    }) 
                })
                if (this.dtlData.length==0){
                    this.promptWin =true
                    this.prompt ='明细资料不能为空'
                }else if ( v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                }else{
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid })), p_table:'QC_CHK',frmid:'412735'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'QC_CHKDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }
                            })
                            //明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'QC_CHKdtl', p_action:'D' },
                                })
                            } 
                            
                            this.addWin =false   
                            this.getPoList('')
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N',ISGIVE:'Y'}
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
        },
 
        getRowKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
         //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='K') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'QC_CHK',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.poData.splice(index,1)
                        } else{   
                            this.getPoList('')     
                            if (val =='Y'){
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }else{
                                Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm })
                            }
                        }
                    }    
                })
            }).catch(()=>{})           
        },
        //状态查询
        stfgChange(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            this.getPoList(cond_+v_cond)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refreq.doLayout()
                //this.$refs['refreq'].setCurrentRow(this.poData(this.v_index))
            }) 
        },
 
        //查询界面
        getPoList(cond){
            let vm =this
            getTabColOrData(this.v_url,'V_QC_CHK','','','CORPID',this.v_corpid,'','',cond ).then((res) => { 
                this.allList =res.result 
                this.initPage() 
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412735','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412735','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412735','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.taskCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.hrCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:20px;
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>